export const showElement = (element): void => {
  if (element) {
    element.classList.remove('hidden')
  }
}

export const hideElement = (element): void => {
  if (element) {
    element.classList.add('hidden')
  }
}

export const getStylePropValue = (element, property: string) => {
  const styles = getComputedStyle(element)
  const value = styles[property]

  return value
}

export const getTemplateContent = template => {
  return template.content.cloneNode(true)
}

export const getTemplateFirstChildContent = template => {
  return template.content.firstElementChild.cloneNode(true)
}

export const setStyleVariable = (variable: string, value: string): void => {
  document.documentElement.style.setProperty(`--gsc-${variable}`, value)
}

export const forwardTransition = (element, isForward: boolean): void => {
  if (element) {
    element.classList.toggle('forward-transition', isForward)
  }
}

export const parseHTML = (html: string): Document => {
  return new DOMParser().parseFromString(html, 'text/html')
}
